import { render, staticRenderFns } from "./DetailBottomBar.vue?vue&type=template&id=2fedcc46&"
import script from "./DetailBottomBar.vue?vue&type=script&lang=js&"
export * from "./DetailBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports